const NewReleaseIcon = () => (
  <svg
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.81128 19.8655L6.02668 16.8578L2.63823 16.1155L2.969 12.627L0.672852 10.0001L2.969 7.37322L2.63823 3.88477L6.02668 3.14247L7.81128 0.134766L10.9997 1.48862L14.1882 0.134766L15.9728 3.14247L19.3612 3.88477L19.0305 7.37322L21.3266 10.0001L19.0305 12.627L19.3612 16.1155L15.9728 16.8578L14.1882 19.8654L10.9997 18.5116L7.81128 19.8655ZM8.44973 17.9501L10.9997 16.8693L13.5805 17.9501L14.9997 15.5501L17.7497 14.9193L17.4997 12.1001L19.3497 10.0001L17.4997 7.86934L17.7497 5.05012L14.9997 4.45012L13.5497 2.05012L10.9997 3.13089L8.41895 2.05012L6.99973 4.45012L4.24973 5.05012L4.49973 7.86934L2.64973 10.0001L4.49973 12.1001L4.24973 14.9501L6.99973 15.5501L8.44973 17.9501ZM9.94973 13.2039L15.2536 7.90012L14.1997 6.81552L9.94973 11.0655L7.79973 8.94629L6.7459 10.0001L9.94973 13.2039Z"
      fill="#1C1B1F"
    />
  </svg>
);

export default NewReleaseIcon;
